/**
 * Account / profile dropdown GTM hooks.
 *
 * Shopify's <shopify-account> UI lives in a closed shadow tree, so we cannot
 * reliably observe email login/create submits inside it. Theme-side we:
 *   1. Push navigation_click when the account control is activated
 *   2. Rely on page_metadata (Liquid) after a full page load post-login
 *   3. Rely on gtm-create-account.liquid for create_account on first session
 *
 * Validate signed-in page_metadata by completing login (full reload) and
 * checking dataLayer — not by expecting pushes from inside the account popup.
 *
 * Clicks that compose out of <shopify-account> are retargeted to the host, so
 * every menu / follow-up interaction would otherwise look like another
 * .account-button click. Track once per open until the user clicks outside.
 */

import { trackNavigationClick } from '@theme/gtm-events';

/** @type {Element | null} */
let accountNavTrackedFor = null;

document.addEventListener(
  'click',
  (e) => {
    const accountButton = /** @type {Element|null} */ (e.target)?.closest?.('.account-button');
    if (!accountButton) {
      accountNavTrackedFor = null;
      return;
    }

    if (accountNavTrackedFor === accountButton) return;
    accountNavTrackedFor = accountButton;

    trackNavigationClick('header', 'Account', '', 'Account', 'Button');
  },
  true
);
